






























import { TournamentAPI } from '@/api/tournament'
import { parseSchema } from '@/utils/customform_validation'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import VFormBase from 'vuetify-form-base'

interface VForm extends HTMLFormElement {
  validate(): boolean
}
const minLen = (l: string) => (v: any) =>
  (v && v.length >= l) || `min. ${l} Characters`
const maxLen = (l: string) => (v: any) =>
  (v && v.length <= l) || `max. ${l} Characters`
const required = (msg: string) => (v: any) => !!v || msg
const requiredArray = (msg: string) => (v: any) =>
  (Array.isArray(v) && v.length > 1) || msg

@Component({
  components: {
    VFormBase
  }
})
export default class TournamentForm extends Vue {
  @Prop({ required: true, type: String }) readonly tournamentId!: string
  @Ref() readonly form!: VForm

  model: any = {}
  schema: any = {}
  isLoading: boolean = false
  isValid: boolean = false

  $reactNativeWebView: any

  async fetchTournamentCustomFormSchema() {
    this.isLoading = true
    try {
      let response = await TournamentAPI.getTournamentCustomFormSchema(
        this.tournamentId
      )
      if (response.data.payload) {
        try {
          this.schema = parseSchema(response.data.payload.schema)
        } catch {
          this.schema = {}
        }
      }
    } catch {
      this.schema = {}
    } finally {
      this.isLoading = false
    }
  }

  async created() {
    await this.fetchTournamentCustomFormSchema()
    // Register fillForm function for react native
    ;(window as any).fillForm = this.fillForm
  }

  // FIXME: temp code

  shouldHide: boolean = false

  get isHide() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('hide') === '1'
  }

  async mounted() {
    if (!this.isHide) {
      return
    }

    try {
      const res = await TournamentAPI.shouldHideForm()
      this.shouldHide = res.data.payload!
    } catch (err) {
      // we don't care
    }
  }

  get theSchema() {
    if (this.shouldHide) {
      const schema = { ...this.schema }
      delete schema['studentidf']
      delete schema['studentidb']

      return schema
    }

    return this.schema
  }

  // end of temp code

  submit() {
    if (!this.form.validate()) return

    this.$reactNativeWebView.postMessage(JSON.stringify(this.model))
  }

  fillForm(value: string) {
    try {
      this.model = JSON.parse(value)
      return true
    } catch {
      alert('Failed to parse tournament form value')
      this.model = {}
      return false
    }
  }

  // "{validationMethod}<::>{arg1}<::>{args2}"
  schemaParser(schemaString: string) {
    var schema: Object = JSON.parse(schemaString)
    for (var property of Object.values(schema)) {
      if (property['rules'] && Array.isArray(property['rules'])) {
        for (var rule of property['rules']) {
          if (typeof rule !== 'string' || !rule.includes('<::>')) {
            continue
          }
          // Attempt to parse for validation function
          var param = rule.split('<::>')

          // Validate min length: "minLen<::>5"
          if (param[0] === 'minLen') {
            rule = minLen(param[1])
          }
        }
      }
    }

    console.log('schemaParser output', schema)
    return schema
  }
}
